import { Empty, Panel } from "../../components/Panel";
import type { ValidationSummary } from "../../types/contract";

/**
 * Validation findings, exactly as the Engine reported them.
 *
 * Blocking and advisory are counted separately and never merged into a score.
 * A single blocking finding is not "97% valid": it is a diagram that cannot be
 * published, and the UI says so in those terms.
 */
export function ValidationPanel({ summary, onRefresh, busy }: {
  summary: ValidationSummary | undefined;
  onRefresh?: () => void;
  busy?: boolean;
}): JSX.Element {
  return (
    <Panel
      title="Validation"
      tone={summary && summary.blocking > 0 ? "error" : "default"}
      actions={onRefresh ? <button type="button" className="ghost" onClick={onRefresh} disabled={busy}>Re-run</button> : undefined}
    >
      {!summary ? <Empty>Not run yet.</Empty> : (
        <>
          <p className="counts">
            <strong className={summary.blocking ? "bad" : "good"}>{summary.blocking}</strong> blocking
            {" · "}
            <strong>{summary.advisory}</strong> advisory
            <span className="muted"> at {summary.canonicalRevision.slice(0, 12)}</span>
          </p>
          {summary.findings.length === 0
            ? <Empty>No findings.</Empty>
            : (
              <ul className="findings">
                {summary.findings.slice(0, 200).map((finding, index) => (
                  <li key={`${finding.code}-${index}`} className={`severity-${finding.severity}`}>
                    <code>{finding.code}</code>
                    <span>{finding.message}</span>
                    {finding.ref?.id && <span className="muted"> → {finding.ref.kind} {finding.ref.id}</span>}
                  </li>
                ))}
              </ul>
            )}
        </>
      )}
    </Panel>
  );
}
